<template>
    <div>
        <h1>Sign up</h1>
    </div>
</template>